import Config from '../API Service/ConfigUrl';

export const initializeAuthListener = () => {
    const config = new Config();
    const handleMessage = (event) => {

        if (event.origin !== "https://rats-web-qa.azurewebsites.net")
            return;

        // if (event.origin !== "http://localhost:5173")
        //     return;

        if (event.data?.type !== "AUTH_TOKEN")
            return;

        localStorage.setItem("workflow_token", event.data.token);
    };

    window.addEventListener("message", handleMessage);

    window.parent.postMessage({ type: "WORKFLOW_READY" }, "https://rats-web-qa.azurewebsites.net");
    // window.parent.postMessage({ type: "WORKFLOW_READY" }, "http://localhost:5173");

    return () => {
        window.removeEventListener("message", handleMessage);
    };
};